import React, { PropsWithChildren } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ThemeWrapper } from '@components/foundation/theme/ThemeWrapper'
import { store } from '@redux/store'
import { useTranslationInit } from './hooks/useTranslationInit'

type WidgetAppProp = {
  appId: string
  brand: string
  locale?: string
} & PropsWithChildren

export const WidgetApp: React.FC<WidgetAppProp> = props => {
  const { appId, brand, locale, children } = props

  useTranslationInit(locale)

  return (
    <Provider store={store}>
      <ThemeWrapper appId={appId} brand={brand}>
        <BrowserRouter>{children}</BrowserRouter>
      </ThemeWrapper>
    </Provider>
  )
}

export const BasicWidgetApp: React.FC<PropsWithChildren> = props => {
  const { children } = props
  return <Provider store={store}>{children}</Provider>
}
